<template>
    <NavbarHome1/>
    <Breadcrumb mainTitle="Helpful FAQ's" subTitle="FAQ's" />
    <!--FAQ Section -->

    <div class="faq-section section-padding pb-50">
        <div class="container">
        <div class="row">
            <div class="col-xl-8 col-lg-8">
            <div class="section-title">
                <h6>If you don't know, find out</h6>
                <h2>Frequently Asked Question</h2>
            </div>
            <div class="accordion faqs" id="accordionFaq">
                <div class="card" v-for="faq in faqs" :key="faq.id">
                    <div class="card-header" id="heading1">
                        <h5 class="mb-0 subtitle">
                        <button class="btn btn-link collapsed" type="button" data-bs-toggle="collapse" :data-bs-target="'#collapse-'+faq.id" aria-expanded="false" aria-controls="collapse7">
                           {{faq.question}}
                        </button>
                        </h5>
                    </div>

                    <div :id="'collapse-'+faq.id" class="collapse" aria-labelledby="heading1" data-parent="#accordionFaq">
                        <div class="card-body">
                        <div class="content">
                            <p>{{faq.answer}}</p>
                        </div>
                        </div>
                    </div>
                </div>
                  
            </div>
            </div>
            <div class="col-xl-4 col-lg-4">
                <div class="helpline-section">
                        <div class="helpline-content text-     
                        c                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             center">
                            <h4>Need Help?</h4>
                            <p>Get in touch with us for a no obligation consultation today!</p>
                            <button onclick="location.href='/contact'" class="btn btn-primary" type="submit">Contact Us</button>
                        </div>
                    </div>
            </div>
        </div>
        </div>
    </div>
    
</template>

<script>
// @ is an alias to /src
import NavbarHome1 from '@/components/NavbarHome1.vue'
import Breadcrumb from '@/components/Breadcrumb.vue'

import axios from 'axios'

export default {
    name: 'Faq',
    components : {NavbarHome1,  Breadcrumb},
    data(){
        return {
            faqs : []
        }
    },

    async mounted(){
        //scrolling to top of the window
        window.scrollTo(0, 0);
                
        let fecthedData = await axios.get("/assets/data/faqs.json");
        this.faqs = fecthedData.data.faqs;
    }
}
</script>